(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2875],{

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ExternalLinkIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/external-link.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "group2691"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "rectangle139",
    d: "M3 1v8h8V1H3M2 0h10v10H2Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "path293",
    d: "M7.83 12H0V4.245h1V11h6.83Z"
  }))));
};
/* harmony default export */ var external_link = (SvgExternalLink);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread({
    "aria-label": "\u65B0\u898F\u30BF\u30D6\u3067\u958B\u304F",
    size: size
  }, props));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(external_link).withConfig({
  displayName: "ExternalLink__StyledIcon",
  componentId: "sc-12ugb1p-0"
})(["transition:fill 0.3s ease-out;fill:", ";width:", ";height:", ";@media screen and (max-width:1047px){width:12px;height:12px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '12px' : '16px';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? '12px' : '16px';
});

/***/ }),

/***/ 53300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ LinkCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx + 1 modules
var ExternalLink = __webpack_require__(62253);
// EXTERNAL MODULE: ./src/components/elements/RoundedLabel/index.tsx
var RoundedLabel = __webpack_require__(51342);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/Card.tsx






var Card = function Card(_ref) {
  var imgPath = _ref.imgPath,
      title = _ref.title,
      detail = _ref.detail,
      isExternalLink = _ref.isExternalLink;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: imgPath,
          width: "100%",
          alt: ""
        })
      }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: title
      })]
    }), detail && /*#__PURE__*/(0,jsx_runtime.jsx)(Detail, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: detail
        }), isExternalLink && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledExternalLinkIcon, {
          size: "small"
        })]
      })
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Wrapper",
  componentId: "sc-1z091jq-0"
})(["width:316px;height:100%;background:", ";border-radius:8px;display:flex;flex-direction:column;@media screen and (max-width:1047px){width:100%;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Grid",
  componentId: "sc-1z091jq-1"
})(["display:grid;grid-template-columns:20px 1fr 20px;grid-template-rows:1fr auto 17px;@media screen and (max-width:1047px){grid-template-rows:1fr auto 17px;}"]);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__ImageWrapper",
  componentId: "sc-1z091jq-2"
})(["display:flex;justify-content:center;grid-area:1 / 1 / 4 / 4;height:188px;transition:opacity 0.25s ease;@media screen and (max-width:1047px){height:199px;}"]);
var Title = (0,styled_components_browser_esm/* default */.ZP)(RoundedLabel/* RoundedLabel */.I).withConfig({
  displayName: "Card__Title",
  componentId: "sc-1z091jq-3"
})(["grid-area:2 / 2 / 3 / 3;"]);
var Detail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Detail",
  componentId: "sc-1z091jq-4"
})(["background:#fff;padding:18px 26px 22px;border-width:0 4px 4px 4px;border-color:", ";border-style:solid;border-radius:0 0 8px 8px;line-height:1.4;letter-spacing:0.08em;flex:1;@media screen and (max-width:1047px){padding:13px 18px 16px;font-size:14px;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var StyledExternalLinkIcon = (0,styled_components_browser_esm/* default */.ZP)(ExternalLink/* ExternalLinkIcon */.h).withConfig({
  displayName: "Card__StyledExternalLinkIcon",
  componentId: "sc-1z091jq-5"
})(["margin-left:8px;"]);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/index.tsx


var _excluded = ["link", "isExternalLink", "isScroll", "newWindow", "forceReload"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var LinkCard = function LinkCard(_ref) {
  var link = _ref.link,
      isExternalLink = _ref.isExternalLink,
      isScroll = _ref.isScroll,
      newWindow = _ref.newWindow,
      forceReload = _ref.forceReload,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (link) {
    if (isExternalLink) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread(_objectSpread({}, props), {}, {
          isExternalLink: isExternalLink
        }))
      });
    }

    if (isScroll) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledScroll, {
        to: link,
        smooth: true,
        duration: 600,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
      });
    }

    var cardLink = /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
      href: forceReload ? link : undefined,
      target: newWindow ? '_blank' : undefined,
      rel: newWindow ? 'noopener noreferrer' : undefined,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
    });

    if (forceReload) return cardLink;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: link,
      passHref: true,
      children: cardLink
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
  });
};
var LinkStyle = (0,styled_components_browser_esm/* css */.iv)(["display:block;width:316px;white-space:pre-wrap;&:hover > div > div:first-of-type{> div > img{opacity:0.6;transition:opacity 0.25s ease;}> div:nth-of-type(2){background:", ";transition:background 0.25s ease;}}@media screen and (max-width:1047px){width:335px;}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "LinkCard__StyledLink",
  componentId: "sc-1q4bvyj-0"
})(["", ""], LinkStyle);
var StyledScroll = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
  displayName: "LinkCard__StyledScroll",
  componentId: "sc-1q4bvyj-1"
})(["", ""], LinkStyle);

/***/ }),

/***/ 51342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RoundedLabel; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var RoundedLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RoundedLabel",
  componentId: "sc-1s4si24-0"
})(["color:#fff;background:", ";border-radius:23px;border:2px solid #fff;padding:12px 20px;font-size:17px;line-height:1.1;letter-spacing:0.04em;font-weight:700;word-break:break-all;text-align:center;position:relative;transition:background 0.25s ease;@media screen and (max-width:1047px){border-radius:25px;font-size:15px;padding:12px 50px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 5801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ CompanyLinks; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _utils_enroutes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9058);
/* harmony import */ var _components_elements_LinkCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53300);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var CompanyLinks = function CompanyLinks(_ref) {
  var padding = _ref.padding;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CompanyNaviListWrapper, {
    padding: padding,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CompanyNaviList, {
      children: _utils_enroutes__WEBPACK_IMPORTED_MODULE_0__/* .COMPANY_ROUTE.subdirectories.map */ .Ir.subdirectories.map(function (_ref2) {
        var path = _ref2.path,
            name = _ref2.name,
            imagePath = _ref2.imagePath;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_elements_LinkCard__WEBPACK_IMPORTED_MODULE_1__/* .LinkCard */ .k, {
            link: path,
            title: name,
            imgPath: imagePath
          })
        }, name);
      })
    })
  });
};
var CompanyNaviListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CompanyLinks__CompanyNaviListWrapper",
  componentId: "sc-vltl97-0"
})(["margin:0 auto;padding:", ";width:1040px;@media screen and (max-width:1047px){padding:", ";width:100%;display:", ";}"], function (_ref3) {
  var padding = _ref3.padding;
  return padding.pc;
}, function (_ref4) {
  var padding = _ref4.padding;
  return padding.sp;
}, function (_ref5) {
  var padding = _ref5.padding;
  return !padding.sp && 'none';
});
var CompanyNaviList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "CompanyLinks__CompanyNaviList",
  componentId: "sc-vltl97-1"
})(["display:flex;flex-wrap:wrap;gap:66px 46px;@media screen and (max-width:1047px){justify-content:center;gap:38px;li:nth-child(odd):last-child{margin-right:388px;}}@media screen and (max-width:700px){li:nth-child(odd):last-child{margin-right:0;}}"]);

/***/ }),

/***/ 32056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | TRIAL Holdings, Inc.") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 37419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ TopMessagePage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Company/CompanyLinks/index.tsx
var CompanyLinks = __webpack_require__(5801);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Company/TopMessage/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var sectionTitle = {
  enTitleText: 'Top Message'
};
var TopMessagePage = function TopMessagePage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Top Message | TRIAL Holdings, Inc.",
      description: "\"Enriching the world through Retail DX\" A message from the Chairman.",
      ogp: {
        type: 'article',
        url: 'en/company/topmessage/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TopMessageContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TopMessageTitle, {
        style: {
          marginBottom: '70px'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
          color: "normal",
          enTitleText: sectionTitle.enTitleText
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/images/Sign_Hiro_Nagata_EN.png",
          style: {
            width: '100%'
          },
          alt: "Hiro Nagata"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TopMessageText, {
        style: {
          marginTop: '70px'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "In 1974, Asahiya, the predecessor of TRIAL, was founded. In 1984, we rebranded as TRIAL Company, Inc., and from that moment, guided by the vision \u201CTransforming retail with IT,\u201D we have continued to embrace challenges."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "At that time, we visited Walmart stores in the United States and witnessed how, harnessing IT, they were experiencing rapid growth through the \u201CSuper Center\u201D format. We were deeply impressed by how the \u201Cinformational revolution in the retail industry\u201D enriched people\u2019s lives, and this experience profoundly inspired us."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "We aspired to spark an \u201Cinformational revolution in the retail industry\u201D in Japan too\u2014to enrich and enhance people\u2019s lives and thereby create a society that delivers happiness through the familiar comforts of everyday living. That \u201Cambition\u201D has been our driving force."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Today, the TRIAL Group is guided by the vision \u201CRevolutionize \u2018real commerce\u2019 around the globe with technology and practical savvy.,\u201D and we continue to pursue bold innovation."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "My mission is to elevate this \u201Cambition\u201D into a sustainable \u201Csystem\u201D powered by each employee\u2019s efforts, paving the way for enduring growth. With an eye on the next 100 years, we are building a robust management foundation and evolving into a visionary company."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "The journey ahead will not be easy. Yet, because so many employees, partners, and\u2014most importantly\u2014customers share in our passion that defies conventional logic or norms, the TRIAL Group stands where it is today."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Gathering with our colleagues and boldly challenging the future, that spirit is the very essence of our name, \u201CTRIAL.\u201D"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "What lies at the end of our journey? A richer life for our customers. By passing on the fruits of transformation through \u201Cbetter quality at lower cost,\u201D and leveraging technology, we will create unprecedented convenience and entirely new shopping experiences."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "All of us at the TRIAL Group are committed to serving our customers and further improving distribution in Japan, now and in the years to come."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RightSign, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["TRIAL Holdings, Inc.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Representative Director and President", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "Hiro Nagata"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLinks/* CompanyLinks */.b, {
        padding: {
          pc: '180px 0 0'
        }
      })]
    })]
  });
};

TopMessagePage.getLayout = function getLayout(page) {
  var pageTitle = {
    title: 'Corporate Information',
    subTitle: ''
  };
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Corporate Information',
    path: '/en/company/'
  }, {
    name: 'Top Message',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: true,
    children: page
  }));
};

var TopMessageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TopMessage__TopMessageContainer",
  componentId: "sc-80mvc1-0"
})(["width:1040px;padding-bottom:130px;padding-top:83px;margin:0 auto;@media screen and (max-width:1047px){width:100%;padding:40px 20px 35px;}"]);
var TopMessageTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TopMessage__TopMessageTitle",
  componentId: "sc-80mvc1-1"
})(["width:100%;display:flex;flex-direction:column;margin-bottom:140px;row-gap:69px;@media screen and (max-width:1047px){margin-bottom:58px;row-gap:36px;}"]);
var TopMessageText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TopMessage__TopMessageText",
  componentId: "sc-80mvc1-2"
})(["width:100%;font-size:18px;color:", ";text-align:left;letter-spacing:0.36px;line-height:32px;margin-top:140px;h3{font-size:28px;letter-spacing:1.68px;font-weight:bold;color:", ";margin-bottom:44px;}p{margin-bottom:2em;}@media screen and (max-width:1047px){font-size:15px;letter-spacing:0.6px;line-height:25px;margin-top:58px;margin-bottom:0px;h3{max-width:225px;font-size:20px;letter-spacing:2px;line-height:30px;margin-bottom:30px;}}"], theme/* theme.colors.textTitle */.r.colors.textTitle, theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var RightSign = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TopMessage__RightSign",
  componentId: "sc-80mvc1-3"
})(["text-align:right;line-height:30px;margin-top:68px;h4{margin-top:24px;font-size:25px;}@media screen and (max-width:1047px){letter-spacing:0.3px;margin-top:46px;h4{margin-top:20px;font-size:24px;letter-spacing:0.48px;}}"]);
;// CONCATENATED MODULE: ./src/pages/en/company/topmessage.tsx


/***/ }),

/***/ 49682:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/company/topmessage",
      function () {
        return __webpack_require__(37419);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,4591,9774,2888,179], function() { return __webpack_exec__(49682); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);